import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useDocumentMeta = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // Ensure i18n is ready and language is detected
    if (!i18n.isInitialized) return;

    // Debug: Uncomment to track meta updates
    // console.log('Updating document meta:', {
    //   language: i18n.language,
    //   title: t('app.title'),
    //   description: t('app.description')
    // });

    // Update document title
    document.title = t('app.title');
    
    // Update html lang attribute
    document.documentElement.lang = i18n.language;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', t('app.description'));
    }
  }, [t, i18n.language, i18n.isInitialized]);

  // Also listen for language change events
  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      // 
      // Small delay to ensure translations are loaded
      setTimeout(() => {
        document.title = t('app.title');
        document.documentElement.lang = lng;
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
          metaDescription.setAttribute('content', t('app.description'));
        }
      }, 100);
    };

    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [t, i18n]);
};